import { getSessionId } from "./metrics";

export const AMPLITUDE_SESSION_ID_HEADER = "X-Amplitude-Session-Id";

/**
 * Correlation headers for one outgoing request to our API.
 *
 * Sent on every request so no backend event can be emitted without the browser
 * session that caused it. The session header is omitted entirely when no
 * session exists; a placeholder would be read as real. Nothing here throws:
 * this is built inside the request wrappers, where an exception would surface
 * to the user as a failed request.
 */
export function metricsRequestHeaders(): Record<string, string> {
  const sessionId = getSessionId();
  if (sessionId === null) return {};
  return { [AMPLITUDE_SESSION_ID_HEADER]: String(sessionId) };
}
